{
  "de": {
    "session": {
      "error_internalserver": {
        "goback": "Zurück",
        "subtitle": "Hoppla, es ist ein unerwarteter Fehler aufgetreten.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Zurück",
        "subtitle": "Entschuldigung, die gesuchte Seite konnte nicht gefunden werden.",
        "title": "404"
      },
      "expired": {
        "text": "Ihre Sitzung ist aufgrund von Inaktivität abgelaufen. Aus Sicherheitsgründen müssen Sie sich erneut anmelden. \n\nKlicken Sie auf OK, um zur Anmeldeseite weitergeleitet zu werden.",
        "title": "Sitzung abgelaufen"
      },
      "logout_impersonate": {
        "text": "Während der Identitätsübernahme wurde eine Abmeldeaktion ausgelöst.",
        "title": "Identitätsübernahme beendet"
      },
      "noaccess": {
        "text": "Sie könnten von unserem neuesten <b>Update</b> betroffen sein: <p></p> <ul> <li>&nbsp;</li> <li><b>Teammitglieder und Partner</b> haben ab sofort Zugriff (und können sich anmelden) über <b>ziggu.app</b> (statt über <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Kunden</b> sind nicht betroffen und können weiterhin über <b><i>%company%</i>.ziggu.app</b> auf die Plattform zugreifen </ul> <p>&nbsp;</p> <p>Wenn Sie auf OK klicken, werden Sie zur entsprechenden Seite weitergeleitet.</p> <p>Falls weiterhin Probleme auftreten, kontaktieren Sie uns bitte.</p>",
        "title": "Hoppla.. Sie scheinen keinen Zugriff (mehr) auf diese Seite zu haben."
      }
    }
  }
}
